import {LanguageSwitcherContent} from "@bounce/shared/consumer/components";
import {SelectChangeEvent} from "@mui/material";
import {Pages} from "~/bi-events/enum";
import React from "react";
import {useAmplitude, useWeglot} from "~/contexts";

export const LanguageSwitcher = () => {
  const {pageClickEvent} = useAmplitude();
  const {currLanguage, switchLanguage} = useWeglot();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedLanguage = event.target.value;
    switchLanguage(selectedLanguage);
    pageClickEvent({
      page: Pages.LANGUAGE_SWITCHER,
      cta: "switch",
      data: {selected: selectedLanguage},
    });
  };

  if (!window.Weglot) return null;

  return <LanguageSwitcherContent currLanguage={currLanguage} handleChange={handleChange} />;
};
